export default __webpack_public_path__ + "static/media/basic-loading.a93950f0.svg";